import { PageContainer } from '@amelio/ui-library';

import type { PerformanceProFeatureValue } from '@/constants/PerformanceProFeature';

import { EmptyState } from '@/components/EmptyState/EmptyState';
import { useAmelioTranslations } from '@/hooks';
import { requestPerformanceUpgrade } from '@/utils/requestPerformanceUpgrade';

interface LockedFeatureStateProps {
    feature: PerformanceProFeatureValue;
}

/**
 * What a Performance PRO page shows a reader who could buy it, reached by its address rather than
 * through a locked menu entry: the page stays put and offers the upgrade instead of sending them away.
 */
export const LockedFeatureState = ({ feature }: LockedFeatureStateProps) => {
    const { t } = useAmelioTranslations();

    return (
        <PageContainer>
            <EmptyState
                title={t('performancePro.lockedTitle')}
                message={t('performancePro.lockedMessage')}
                action={{
                    label: t('performancePro.unlockAction'),
                    iconName: 'security-lock',
                    onClick: () => requestPerformanceUpgrade(feature),
                }}
            />
        </PageContainer>
    );
};
